import "./AppFooter.scss";

const getAppVersion = (): string => {
  return (
    (window as any).__SHOPEG_ADMIN_DEV_VERSION__ ||
    (window as any).__SHOPEG_ADMIN_PROD_VERSION__ ||
    "1.0.0"
  );
};

const AppFooter = () => {
  const version = getAppVersion();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="app-footer">
      <span className="app-footer__text">
        © {currentYear}{" "}
        <a
          href="https://shopeg.in?utm_source=admin_dashboard&utm_medium=footer&utm_campaign=copyright"
          target="_blank"
          rel="noopener noreferrer"
          className="app-footer__link"
        >
          ShopEG
        </a>
        . All rights reserved.
      </span>
      <span className="app-footer__version">v{version}</span>
    </footer>
  );
};

export default AppFooter;
